import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const FIVE_MINUTES = 5 * 1000 * 60

const opalQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: 'always',
      staleTime: FIVE_MINUTES,
      keepPreviousData: true,
      useErrorBoundary: true,
      retry: 1,
    },
  },
})

if (window.top) {
  window.top.OPAL_QUERY_CLIENT = window.top.OPAL_QUERY_CLIENT || opalQueryClient
} else {
  window.OPAL_QUERY_CLIENT = window.OPAL_QUERY_CLIENT || opalQueryClient
}

export const DefaultQueryClientProvider = ({
  children,
}: {
  children?: React.ReactNode
}) => {
  return (
    <QueryClientProvider
      client={window.top?.OPAL_QUERY_CLIENT ?? opalQueryClient}
    >
      {children}
    </QueryClientProvider>
  )
}
